export interface CartItem {
  productId: number;
  quantity: number;
  price: number;
  discount_percent?: number;
  discount_amount?: number;
  total_price?: number;
  notes?: string;
}

export interface CartValidationResult {
  totalAmount: number;
  isValid: boolean;
  errors: string[];
}

export const cartService = {
  // Validate giỏ hàng
  validateCart: async (cart: CartItem[]): Promise<CartValidationResult> => {
    try {
      let totalAmount = 0;
      const errors: string[] = [];

      for (const item of cart) {
        if (item.quantity <= 0) {
          errors.push(`Số lượng sản phẩm ${item.productId} phải lớn hơn 0`);
          continue;
        }

        if (item.price <= 0) {
          errors.push(`Giá sản phẩm ${item.productId} phải lớn hơn 0`);
          continue;
        }

        const itemTotal = (item.price * item.quantity) - (item.discount_amount || 0);
        totalAmount += itemTotal;
      }

      return {
        totalAmount,
        isValid: errors.length === 0,
        errors
      };
    } catch (error) {
      console.error('Error validating cart:', error);
      throw error;
    }
  },

  // Tính tổng tiền giỏ hàng
  calculateTotal: (cart: CartItem[]): number => {
    return cart.reduce((total, item) => {
      const itemTotal = (item.price * item.quantity) - (item.discount_amount || 0);
      return total + itemTotal;
    }, 0);
  },

  // Thêm sản phẩm vào giỏ hàng
  addToCart: (cart: CartItem[], product: any, quantity: number = 1): CartItem[] => {
    const existingItem = cart.find(item => item.productId === product.id);
    
    if (existingItem) {
      return cart.map(item => 
        item.productId === product.id 
          ? { ...item, quantity: item.quantity + quantity }
          : item
      );
    }

    return [...cart, {
      productId: product.id,
      quantity,
      price: product.price || 0,
      discount_percent: 0,
      discount_amount: 0,
      total_price: (product.price || 0) * quantity
    }];
  },

  // Cập nhật số lượng sản phẩm
  updateQuantity: (cart: CartItem[], productId: number, quantity: number): CartItem[] => {
    if (quantity <= 0) {
      return cart.filter(item => item.productId !== productId);
    }

    return cart.map(item => 
      item.productId === productId 
        ? { ...item, quantity, total_price: (item.price * quantity) - (item.discount_amount || 0) }
        : item
    );
  },

  // Xóa sản phẩm khỏi giỏ hàng
  removeFromCart: (cart: CartItem[], productId: number): CartItem[] => {
    return cart.filter(item => item.productId !== productId);
  },

  // Xóa toàn bộ giỏ hàng
  clearCart: (): CartItem[] => {
    return [];
  }
};